module.exports = __webpack_public_path__ + "img/about_premium_2.ffe96091.png";